import { render } from "./VerticalNavMenuLink.vue?vue&type=template&id=ac67ceac"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
script.render = render

export default script